import axios from '../utils/axiosConfig';

// Use local backend proxy to avoid CORS issues
const API_URL = '';

// Helper to format volume
const formatVolume = (num) => {
    if (num >= 1000000) return `$${(num / 1000000).toFixed(1)}M`;
    if (num >= 1000) return `$${(num / 1000).toFixed(1)}K`;
    return `$${num}`;
};

// Enhanced mock data with full details
const ENHANCED_MOCK_DATA = [
    {
        id: 'btc-100k',
        slug: 'bitcoin-100k-2026',
        title: "Will Bitcoin hit $100k before Q4 2026?",
        description: "This market resolves YES if BTC trades above $100,000 on any major exchange before October 1, 2026.",
        ticker: "BTC-100K",
        rawVolume: 45200000,
        volume: "$45.2M",
        liquidity: 2500000,
        liquidityFormatted: "$2.5M",
        image: "https://images.unsplash.com/photo-1518546305927-5a555bb7020d?q=80&w=400",
        source: "Polymarket",
        category: "Crypto",
        endDate: "2026-10-01",
        outcomes: [
            { name: 'Yes', price: 0.68, percentage: 68 },
            { name: 'No', price: 0.32, percentage: 32 }
        ],
        long: 68,
        short: 32,
        participants: 12500
    },
    {
        id: 'sol-eth',
        slug: 'solana-ethereum-flip',
        title: "Solana Market Cap > Ethereum by 2026?",
        description: "Resolves YES if Solana's market cap exceeds Ethereum's at any point in 2026.",
        ticker: "SOL-FLIP",
        rawVolume: 18500000,
        volume: "$18.5M",
        liquidity: 980000,
        liquidityFormatted: "$980K",
        image: "https://images.unsplash.com/photo-1621416894569-0f39ed31d247?q=80&w=400",
        source: "Polymarket",
        category: "Crypto",
        endDate: "2026-12-31",
        outcomes: [
            { name: 'Yes', price: 0.32, percentage: 32 },
            { name: 'No', price: 0.68, percentage: 68 }
        ],
        long: 32,
        short: 68,
        participants: 8200
    },
    {
        id: 'us-election-28',
        slug: 'us-election-2028',
        title: "US Election 2028: Democrat vs Republican",
        description: "Which party will win the 2028 US Presidential Election?",
        ticker: "POL-28",
        rawVolume: 102100000,
        volume: "$102.1M",
        liquidity: 5800000,
        liquidityFormatted: "$5.8M",
        image: "https://images.unsplash.com/photo-1540910419868-474947ce09fe?q=80&w=400",
        source: "Polymarket",
        category: "Politics",
        endDate: "2028-11-05",
        outcomes: [
            { name: 'Democrat', price: 0.51, percentage: 51 },
            { name: 'Republican', price: 0.49, percentage: 49 }
        ],
        long: 51,
        short: 49,
        participants: 45000
    },
    {
        id: 'spacex-mars',
        slug: 'spacex-mars-2026',
        title: "SpaceX Starship Mars Landing in 2026?",
        description: "Will SpaceX successfully land Starship on Mars by end of 2026?",
        ticker: "SPX-MARS",
        rawVolume: 12800000,
        volume: "$12.8M",
        liquidity: 720000,
        liquidityFormatted: "$720K",
        image: "https://images.unsplash.com/photo-1516849841032-87cbac4d88f7?q=80&w=400",
        source: "Polymarket",
        category: "Science",
        endDate: "2026-12-31",
        outcomes: [
            { name: 'Yes', price: 0.45, percentage: 45 },
            { name: 'No', price: 0.55, percentage: 55 }
        ],
        long: 45,
        short: 55,
        participants: 6800
    },
    {
        id: 'gpt-6',
        slug: 'openai-gpt6',
        title: "OpenAI Releases GPT-6 before Jan 2027?",
        description: "Resolves YES if OpenAI announces GPT-6 (or equivalent next-gen model) before January 1, 2027.",
        ticker: "AI-GPT6",
        rawVolume: 8900000,
        volume: "$8.9M",
        liquidity: 450000,
        liquidityFormatted: "$450K",
        image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?q=80&w=400",
        source: "Polymarket",
        category: "Tech",
        endDate: "2027-01-01",
        outcomes: [
            { name: 'Yes', price: 0.82, percentage: 82 },
            { name: 'No', price: 0.18, percentage: 18 }
        ],
        long: 82,
        short: 18,
        participants: 4500
    },
    {
        id: 'super-bowl',
        slug: 'chiefs-superbowl-2026',
        title: "Kansas City Chiefs Win Super Bowl 2026?",
        description: "Will the Kansas City Chiefs win Super Bowl LX?",
        ticker: "NFL-SB",
        rawVolume: 22400000,
        volume: "$22.4M",
        liquidity: 1200000,
        liquidityFormatted: "$1.2M",
        image: "https://images.unsplash.com/photo-1514525253440-b393452e8d26?q=80&w=400",
        source: "Polymarket",
        category: "Sports",
        endDate: "2026-02-15",
        outcomes: [
            { name: 'Yes', price: 0.18, percentage: 18 },
            { name: 'No', price: 0.82, percentage: 82 }
        ],
        long: 18,
        short: 82,
        participants: 15200
    },
    {
        id: 'fed-rates',
        slug: 'fed-rate-cut-2026',
        title: "Fed Interest Rate Cut > 75bps in 2026?",
        description: "Will the Federal Reserve cut interest rates by more than 75 basis points total in 2026?",
        ticker: "FED-RATES",
        rawVolume: 35600000,
        volume: "$35.6M",
        liquidity: 1800000,
        liquidityFormatted: "$1.8M",
        image: "https://images.unsplash.com/photo-1611974765270-ca1258634369?q=80&w=400",
        source: "Polymarket",
        category: "Economics",
        endDate: "2026-12-31",
        outcomes: [
            { name: 'Yes', price: 0.25, percentage: 25 },
            { name: 'No', price: 0.75, percentage: 75 }
        ],
        long: 25,
        short: 75,
        participants: 22000
    },
    {
        id: 'nvidia-5t',
        slug: 'nvidia-5-trillion',
        title: "NVIDIA Market Cap > $5 Trillion in 2026?",
        description: "Will NVIDIA's market capitalization exceed $5 trillion at any point in 2026?",
        ticker: "NVDA-CAP",
        rawVolume: 67300000,
        volume: "$67.3M",
        liquidity: 3200000,
        liquidityFormatted: "$3.2M",
        image: "https://images.unsplash.com/photo-1629739884942-887f6b6bddf3?q=80&w=400",
        source: "Polymarket",
        category: "Stocks",
        endDate: "2026-12-31",
        outcomes: [
            { name: 'Yes', price: 0.55, percentage: 55 },
            { name: 'No', price: 0.45, percentage: 45 }
        ],
        long: 55,
        short: 45,
        participants: 28000
    }
];

// Helper for aggressive deduplication
const deduplicateMarkets = (markets) => {
    if (!markets || !Array.isArray(markets)) return [];

    const seen = new Set();
    return markets.filter(market => {
        const polyId = market.polymarketId || market.id;
        const slug = market.slug || market.marketSlug;
        const normalizedTitle = (market.title || market.question || '').toLowerCase().trim();

        // If question contains certain keywords, it might be a different variant of the same topic
        // But for UI, we usually only want the lead/main market
        const uniqueKeys = [polyId, slug, normalizedTitle].filter(Boolean);

        for (const key of uniqueKeys) {
            if (seen.has(key)) return false;
        }

        uniqueKeys.forEach(key => seen.add(key));
        return true;
    });
};

// Fetch all markets with full details for All Markets page
export const fetchAllMarkets = async (options = {}) => {
    const { limit = 50, category = null, search = null, sortBy = 'volume' } = options;

    try {
        const params = { limit: limit * 2 }; // Fetch more to allow for aggressive deduplication
        if (category && category !== 'All') {
            params.category = category;
        }

        const response = await axios.get(`${API_URL}/markets`, { params });

        if (response.data && Array.isArray(response.data)) {
            const rawData = response.data;
            const dedupedData = deduplicateMarkets(rawData);

            return dedupedData.slice(0, limit).map(event => ({
                id: event.slug || event.polymarketId,
                slug: event.slug,
                title: event.title || event.question,
                description: event.description || '',
                ticker: 'POLY', // Default
                rawVolume: event.volume || 0,
                volume: formatVolume(event.volume || 0),
                liquidity: event.liquidity || 0,
                liquidityFormatted: formatVolume(event.liquidity || 0),
                // UAT HIGH-005: Use Polymarket image if available, fallback to placeholder
                image: event.image || event.imageUrl || 'https://images.unsplash.com/photo-1611974765270-ca1258634369?q=80&w=400',
                source: event.source || 'Polymarket',
                category: event.category || 'General',
                endDate: event.endDate || null,
                outcomes: event.outcomes || [],
                // Calculate percentages for UI bars if needed
                outcomesFormatted: (event.outcomes || []).map(o => ({
                    name: o.name,
                    price: o.price,
                    percentage: Math.round((o.price || 0) * 100)
                })),
                chance: event.outcomes && event.outcomes.length > 0 ? Math.round((event.outcomes[0].price || 0) * 100) : 50,
                validations: event.validations || 0,
                active: event.active,
                participants: Math.floor((event.volume || 0) / 50), // Rough estimate if not provided
                agentScore: event.agent_score,
                platformPrediction: event.platform_prediction
            }));
        }
    } catch (error) {
        console.warn("Backend API error, using enhanced mock data. PLEASE VERIFY BACKEND CONNECTION:", error);
        // TODO: In production, consider showing a 'Live Data Unavailable' toast notification here.
    }

    // Return enhanced mock data as fallback
    return ENHANCED_MOCK_DATA.filter(m =>
        (!category || category === 'All' || m.category === category)
    );
};

// Fetch markets for Top Markets section (limited)
export const fetchMarkets = async () => {
    return fetchAllMarkets({ limit: 8 });
};

// Simulate Live Updates (Fluctuate Volume & Chance)
export const simulateLiveUpdates = (markets) => {
    return markets.map(market => {
        const isVolatile = Math.random() > 0.7;
        if (!isVolatile) return market;

        const volumeChange = Math.floor(Math.random() * 50000);
        const newRawVolume = (market.rawVolume || 1000000) + volumeChange;

        const chanceChange = Math.random() > 0.5 ? 1 : -1;
        let newChance = (market.chance || 50) + (Math.random() > 0.8 ? chanceChange : 0);
        newChance = Math.max(1, Math.min(99, newChance));

        return {
            ...market,
            rawVolume: newRawVolume,
            volume: formatVolume(newRawVolume),
            chance: newChance,
            long: newChance,
            short: 100 - newChance
        };
    });
};

// Search markets by query - filters and ranks Polymarket events by relevance
export const searchMarkets = async (query) => {
    if (!query || query.trim().length === 0) {
        return fetchMarkets();
    }

    const keywords = query.toLowerCase().split(' ').filter(w => w.length > 2);

    // Get all markets (real or mock)
    const allMarkets = await fetchAllMarkets({ limit: 50 });

    const scoredMarkets = allMarkets.map(market => {
        const titleLower = (market.title || '').toLowerCase();
        const descLower = (market.description || '').toLowerCase();

        let score = 0;
        keywords.forEach(keyword => {
            if (titleLower.includes(keyword)) score += 3;
            if (descLower.includes(keyword)) score += 1;
        });

        return {
            ...market,
            relevanceScore: score,
            isRecommended: score > 0
        };
    });

    scoredMarkets.sort((a, b) => {
        if (b.relevanceScore !== a.relevanceScore) {
            return b.relevanceScore - a.relevanceScore;
        }
        return b.rawVolume - a.rawVolume;
    });

    return scoredMarkets;
};

// Fetch all agent predictions and stats for a specific market
export const fetchMarketConsensus = async (slug) => {
    try {
        const response = await axios.get(`${API_URL}/markets/${slug}/predictions`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching consensus for ${slug}:`, error);
        // Return mock data for UI verification if backend fails
        return {
            predictions: [
                { agentName: 'AlphaOne', probability: 0.75, rationale: 'Strong bullish signal based on recent volume spike and historical resistance break.', timestamp: new Date().toISOString() },
                { agentName: 'BetaBot', probability: 0.60, rationale: 'Moderate confidence, trend is positive but short-term volatility suggests caution.', timestamp: new Date(Date.now() - 3600000).toISOString() },
                { agentName: 'GammaRay', probability: 0.82, rationale: 'Confirmed breakout above resistance levels with sustained momentum.', timestamp: new Date(Date.now() - 7200000).toISOString() },
                { agentName: 'DeltaDelta', probability: 0.45, rationale: 'Slight negative divergence in REX metrics, suggesting a potential pullback.', timestamp: new Date(Date.now() - 10800000).toISOString() },
                { agentName: 'EpsilonX', probability: 0.68, rationale: 'Macro indicators turning favorable for this specific asset class.', timestamp: new Date(Date.now() - 14400000).toISOString() },
                { agentName: 'ZetaPrime', probability: 0.55, rationale: 'Neutral to slightly bullish. Awaiting confirmation from volume profile.', timestamp: new Date(Date.now() - 18000000).toISOString() }
            ],
            stats: {
                total: 6,
                positive: 5,
                negative: 1,
                agent_probability: 64
            }
        };
    }
};
// Fetch single market details by slug
export const fetchMarketBySlug = async (slug) => {
    try {
        const response = await axios.get(`${API_URL}/markets/${slug}`);
        const event = response.data;

        if (!event) throw new Error("Market not found");

        // Calculate long/short from outcomes
        const yesOutcome = event.outcomes?.find(o => o.name?.toLowerCase() === 'yes');
        const longValue = yesOutcome ? Math.round(yesOutcome.price * 100) : 50;

        return {
            id: event.slug || event.polymarketId,
            slug: event.slug,
            title: event.title || event.question,
            description: event.description || '',
            ticker: 'POLY',
            rawVolume: event.volume || 0,
            volume: formatVolume(event.volume || 0),
            liquidity: event.liquidity || 0,
            liquidityFormatted: formatVolume(event.liquidity || 0),
            image: event.image || event.imageUrl || 'https://images.unsplash.com/photo-1611974765270-ca1258634369?q=80&w=400',
            source: event.source || 'Polymarket',
            category: event.category || 'General',
            endDate: event.endDate || null,
            outcomes: event.outcomes || [],
            outcomesFormatted: (event.outcomes || []).map(o => ({
                name: o.name,
                price: o.price,
                percentage: Math.round((o.price || 0) * 100)
            })),
            long: longValue,
            short: 100 - longValue,
            probability: longValue,
            active: event.active,
            participants: Math.floor((event.volume || 0) / 50),
            agentScore: event.agent_score,
            platformPrediction: event.platform_prediction
        };
    } catch (error) {
        console.warn(`Error fetching market ${slug}, using fallback:`, error);
        const mock = ENHANCED_MOCK_DATA.find(m => m.slug === slug || m.id === slug);
        if (mock) return mock;
        throw error;
    }
};
